(async () => {
  const { default: startEasasJsReports } = await import("./indexReports");
  startEasasJsReports();
})();
